import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import ApiLogsStore from "@/store/modules/ApiLogsStore";


export class CmsApiClientLocal {

    public static async getHealth() {
        return "ok"
    }

    public static async getMenus() {
        return (await axios.get("./data/cms/menus.json")).data;
    }

    public static async createMenu(menu: CMS.Menu) {
    }

    public static async editMenu(menu: CMS.Menu) {
    }

    public static async sortMenus(order: number[]) {
    }

    public static async deleteMenu(menu: CMS.Menu) {
    }

    public static async createMenuStore(menu: CMS.Menu, storeId: number) {
    }

    public static async deleteMenuStore(menu: CMS.Menu, storeId: number) {
    }

    public static async updateMenuStores(menu: CMS.Menu) {
    }

    public static async getSchedules(menuId: number) {
        return (await axios.get("./data/cms/schedules.json")).data;
    }

    public static async createSchedule(schedule: CMS.Schedule) {
    }

    public static async editSchedule(schedule: CMS.Schedule) {
    }

    public static async deleteSchedule(schedule: CMS.Schedule) {
    }

    public static async getImages() {
    }

    public static async createImage(image: CMS.Image) {
    }

    public static async editImage(image: CMS.Image) {
    }

    public static async deleteImage(image: CMS.Image) {
    }

    public static async getCategories(menuId: number) {
        return (await axios.get("./data/cms/categories.json")).data;
    }

    public static async createCategory(category: CMS.Category) {
    }

    public static async editCategory(category: CMS.Category) {
    }

    public static async deleteCategory(category: CMS.Category) {
    }

    public static async sortCategory(menuId: number, order: number[]) {
    }

    public static async getCategoryItems(menuId: number) {
        return (await axios.get("./data/cms/category_items.json")).data;
    }

    public static async setCategoryItems(menuId: number, categoryId: number, categoryItems: CMS.CategoryItem[]) {
    }

    public static async getThemes() {
        // const url = host + "/themes";
        // return axios.get(url, makeConfig());

        return (await new Promise<{ data: any }>(async resolve => {
            let theme1: CMS.Theme = <any>{};
            theme1.id = 1;
            theme1.name = "AFURIテーマ";
            theme1.theme_options = (await axios.get("/cms_settings/1/ThemePages.json")).data;
            theme1.theme_category_options = (await axios.get("/cms_settings/1/ThemeCategory.json")).data;
            theme1.theme_item_options = (await axios.get("/cms_settings/1/ThemeItem.json")).data;
            let theme2: CMS.Theme = <any>{};
            theme2.id = 2;
            theme2.name = "テーマ2段";
            theme2.theme_options = (await axios.get("/cms_settings/2/ThemePages.json")).data;
            theme2.theme_category_options = (await axios.get("/cms_settings/2/ThemeCategory.json")).data;
            theme2.theme_item_options = (await axios.get("/cms_settings/2/ThemeItem.json")).data;
            resolve({data: [theme1, theme2]});
        })).data;
    }


    public static async getThemeVariable(themeId: number, menuId: number) {
        return (await axios.get("./data/theme/theme_setting.json")).data;
    }

    public static async setThemeVariable(themeVariable: CMS.ThemeVariable) {
    }

    public static async getThemeCategoryVariables(themeId: number, menuId: number) {
        return (await axios.get("./data/theme/theme_category_settings.json")).data;
    }

    public static async setThemeCategoryVariable(themeCategoryVariable: CMS.ThemeCategoryVariable) {
    }

    public static async getThemeItemVariables(themeId: number) {
        return (await axios.get("./data/theme/theme_item_settings.json")).data;
    }

    public static async setThemeItemVariable(themeItemVariable: CMS.ThemeItemVariable) {
    }

    public static async getItems() {
        return (await axios.get("./data/cms/items.json")).data;
    }

    public static async setItem(item: CMS.Item) {
    }

    public static async getSelections() {
        return [];
    }

    public static async setSelection(selection: CMS.Selection) {
    }

    public static async getCondimentGroups() {
        return (await axios.get("./data/cms/condiment_groups.json")).data;
    }

    public static async setCondimentGroup(condimentGroup: CMS.CondimentGroup) {
    }


    // ----- その他 ------------------------------------------------

    public static async getDeliousItemDetailList(storeId: number, periodId: number) {
        return (await axios.get("./data/delious/delious_item_detail_list.json")).data;
    }

    public static async uploadFile(formData: FormData) {
        const body = formData;
        return (await axios.post("http://mtool.dip.jp/upload.php", body)).data;
    }
}
